import { Typography } from "@mui/material";
import React from "react";
export const About = () => {
    return (React.createElement("div", null,
        React.createElement(Typography, { variant: "h1" }, "About")));
};
